import React from "react";
import "./ChatTyping.css";

const ChatTyping = () => {
  return (
    <div className="typing">
      <div className="typing__dot"></div>
      <div className="typing__dot"></div>
      <div className="typing__dot"></div>
    </div>
  );
};

export default ChatTyping;
